import React, { useState, useEffect } from "react";
import { GridRowModes } from "@mui/x-data-grid";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import {
  gridStyles,
  gridComponents,
} from "../../../issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { editCellContainerStyle } from "../onBoardingMaterialIdSetup/constant";
import { AGridColDef } from "../../../../common/data-grid/ADataGridColDef";
import { Tooltip } from "@mui/material";
import { MdCircle } from "react-icons/md";
import { hasNumber } from "./constants";
import CustomCopyToClipboard from "views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard";

const MessageListComponent = ({ rows = [], loading = false, prNo, showClipboard, msgLabelKey, errorKey }) => {
  const [rowData, setRowData] = useState(rows);
  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  const getColorByType = (code) => {
    switch (code) {
      case "E":
        return "red"; // Error
      case "W":
        return "orange"; // Warning
      case "S":
        return "green"; // Success
      case "I":
        return "blue"; // Info
      default:
        return "gray"; // Default color
    }
  };

  const columns = [
    new AGridColDef("type", "Type", false)
      .setMinWidth(30)
      .setFlex(0.5)
      .editable(false)
      // .setValueGetter((params) => params?.row?.Message_code)
      .renderCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <Tooltip title={`${params?.row?.[errorKey]}`}>
            <MdCircle style={{ color: getColorByType(params?.row?.[errorKey]), fontSize: "20px" }} />
          </Tooltip>
        </div>
      )),
    new AGridColDef("message", "Message Text", false)
      .setMinWidth(180)
      .setFlex(3)
      .editable(false)
      // .setValueGetter((params) => params?.value)
      .renderCellComponent((params) => {
        const message = params?.row?.[msgLabelKey];
        return (
          <div className="d-flex ml-0 pl-0 justfy-content-start align-items-center" style={editCellContainerStyle}>
            <Tooltip title={message}>
              <div>{message}</div>
            </Tooltip>
            {showClipboard && <CustomCopyToClipboard textToCopy={prNo} />}
          </div>
        );
      }),
    new AGridColDef("type2", "Type", false)
      .setMinWidth(30)
      .setFlex(0.5)
      .editable(false)
      // .setValueGetter((params) => params?.value)
      .renderCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <Tooltip title={`${params?.row?.[errorKey]}`}>
            <div>{params?.row?.[errorKey]}</div>
          </Tooltip>
        </div>
      )),
  ];

  return (
    <>
      <div
        className=""
        style={{ border: "1px solid #EEE", borderRadius: "8px" }}
      >
        <ADataGrid
          removeWrapperContainer
          sx={{
            ...gridStyles,
          }}
          // rowModesModel={rowModesModel}
          rows={rowData}
          columns={columns}
          rowId={(row) => row.id}
          rowHeight={50}
          loading={false}
          maxHeight={"300px"}
          rowCount={(rowData || []).length}
          hidePagination
          // currentPage={currentPage}
          // nextButtonHandler={pageChangeHandler}
          components={{
            ...gridComponents,
            NoRowsOverlay: () => (
              <NoRowOverlay message={loading ? "Loading..." : null} />
            ),
          }}
        />
      </div>
    </>
  );
};

export default MessageListComponent;
